<template>
  <Layout>
    <template #header>
      <div class="pcs-header">
        <Heading>{{ $t('ppm_modal__pc_success_heading') }}</Heading>
        <CloseButton @click="$emit('close')" />
      </div>
    </template>

    <template #default>
      <div class="pcs-main">
        <div class="pcs-main-left">
          <PhysicalCard
            class="pcs-card"
            v-bind="getCardProps(paymentAccount)"
          />
        </div>
        <div class="pcs-main-right">
          <Paragraph>
            {{ $t('ppm_modal__pc_success_text_p1') }}
          </Paragraph>
          <Paragraph>
            {{ $t('ppm_modal__pc_success_text_p2') }}
          </Paragraph>
          <Paragraph>
            {{ $t('ppm_modal__pc_success_text_p3') }}
          </Paragraph>
        </div>
      </div>
    </template>

    <template #footer>
      <HotPinkButton @click="$emit('confirm')">
        {{ confirmText }}
      </HotPinkButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../../layouts/Layout.vue'
import Heading from '../../typography/Heading.vue'
import Paragraph from '../../typography/Paragraph.vue'
import PhysicalCard from '../../cards/PhysicalCard.vue'
import HotPinkButton from '../../buttons/HotPinkButton.vue'
import CardMixin from '../../mixins/CardMixin'
import CloseButton from '@/components/shared/Dialogs/CloseButton.vue'

export default {
  components: {
    Layout,
    Heading,
    Paragraph,
    PhysicalCard,
    HotPinkButton,
    CloseButton,
  },
  mixins: [CardMixin],
  props: {
    paymentAccount: {
      type: Object,
      required: true,
    },
    confirmText: {
      type: String,
      default: 'Continue',
    },
  },
}
</script>

<style scoped>
.pcs-header {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-mb-8 tw-gap-1;
}

.pcs-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-6;

  /* Desktop  */
  @apply lg:tw-flex-row lg:tw-mb-4;
}

.pcs-main-left {
  /* Base */
  @apply tw-flex tw-justify-center tw-items-center;
}

.pcs-card {
  /* Base */
  @apply tw-min-w-[264px] tw-min-h-[88px];

  /* Desktop */
  @apply lg:tw-w-[328px] lg:tw-h-[128px];
}

.pcs-main-right {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-4;
}
</style>
